export default __webpack_public_path__ + "static/media/coins_black.8a3feb33.svg";